import {
  runtimeMappingsHistory,
  runtimeMappingsProjects
} from './runtime-mappings';

export const getQueryProjectsById = (
  accountId: string,
  from = 0,
  size = 10
) => ({
  runtime_mappings: {
    ...runtimeMappingsProjects
  },
  fields: ['currentStage', 'parsedSquare', 'deadline'],
  from,
  size,
  query: {
    bool: {
      must: [
        {
          match: {
            'signer_id.keyword': accountId
          }
        }
      ]
    }
  }
});

export const getQueryProjectsByProjectIds = (
  projectIds: number[] | string[],
  from = 0,
  size = 100
) => ({
  from,
  size,
  query: {
    terms: {
      'project_id.keyword': projectIds
    }
  },
  _source: ['name', 'region', 'project_id', 'type', 'stages']
});

export const subProjectsRequestBody = (projectsIds) => ({
  query: {
    bool: {
      must: [
        {
          terms: {
            project_id: [...projectsIds]
          }
        }
      ]
    }
  },
  _source: ['name', 'region', 'project_id', 'stages']
});

type DateRange = {
  startDate: Date;
  endDate: Date;
};

type QueryObj = {
  bool: {
    filter: {
      terms: {
        [key: string]: string[];
      };
    }[];
    must: {
      range?: {
        [key: string]: {
          gte: number;
          lte: number;
        };
      };
      match?: {
        [key: string]: string;
      };
    }[];
  };
};

export const getQueryActivityById = (
  accountId: string,
  type = '',
  date: DateRange,
  page = 1,
  size = 7
) => {
  const from = (page - 1) * size;

  const paramsObj = {
    'user.keyword': accountId,
    'type.keyword': type
  };

  const queryObj: QueryObj = {
    bool: {
      filter: [
        {
          terms: {
            'type.keyword': [
              'opn_send',
              'occ_send',
              'opn_received',
              'occ_received',
              'plant',
              'opn_withdraw',
              'occ_withdraw',
              'offset',
            ]
          }
        }
      ],
      must: [
        {
          range: {
            date_added: {
              gte: new Date(date.startDate).getTime() * 1000000,
              lte: new Date(date.endDate).getTime() * 1000000
            }
          }
        }
      ]
    }
  };

  Object.keys(paramsObj).forEach((key: string) => {
    if (paramsObj[key]) {
      queryObj.bool.must.push({
        match: {
          [key]: paramsObj[key]
        }
      });
    }
  });

  return {
    from,
    size,
    query: {
      ...queryObj
    },
    sort: [
      {
        date_added: {
          order: 'desc'
        }
      }
    ]
  };
};

export const getQueryValidationsById = (accountId: string, from = 0, size = 10) => ({
  query: {
    match: {
      'user.keyword': accountId
    }
  },
  runtime_mappings: {
    ...runtimeMappingsHistory
  },
  fields: [],
  size: 0,
  aggs: {
    projects: {
      aggregations: {
        amountAffirm: {
          sum: {
            field: 'amountAffirm'
          }
        },
        maxTime: {
          max: {
            field: 'date_added'
          }
        },
        amountDeny: {
          sum: {
            field: 'amountDeny'
          }
        },
        buckSort: {
          bucket_sort: {
            sort: [{ maxTime: { order: 'desc' } }],
            from,
            size,
          }
        }
      },
      composite: {
        size: 65536,
        sources: [
          {
            project_id: {
              terms: { field: 'project_id.keyword', order: 'desc' }
            }
          },
          { stage_id: { terms: { field: 'stage_id.keyword' } } }
        ]
      }
    }
  }
});
